exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".home-container .filter-container .card{border:2px solid}.home-container .filter-container .card .card-body{color:#fff}.home-container .filter-container .card .card-body .label{font-weight:400}.home-container .filter-container .card .card-body .button{color:#000}", ""]);

